function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgCrown = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    enableBackground: "new 0 0 512 512"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
  x: 49.676,
  y: 401.045,
  style: {
    fill: "#FFB655"
  },
  width: 412.654,
  height: 44.568
}), /*#__PURE__*/React.createElement("rect", {
  x: 49.676,
  y: 401.045,
  style: {
    fill: "#FF7956"
  },
  width: 44.568,
  height: 44.568
}), /*#__PURE__*/React.createElement("rect", {
  x: 34.957,
  y: 445.614,
  style: {
    fill: "#FFE477"
  },
  width: 442.094,
  height: 43.449
}), /*#__PURE__*/React.createElement("rect", {
  x: 34.957,
  y: 445.614,
  style: {
    fill: "#FFB655"
  },
  width: 43.449,
  height: 43.449
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FFE477"
  },
  points: "477.05,77.854 366.524,213.739 255.996,77.854 145.475,213.739 34.957,77.854  34.957,401.041 477.05,401.041 "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FFB655"
  },
  points: "105.928,285.205 133.309,318.87 160.693,285.205 133.309,251.539  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FFB655"
  },
  points: "448.428,285.205 421.045,318.87 393.663,285.205 421.045,251.539  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FFB655"
  },
  points: "219.049,285.205 277.176,356.671 335.306,285.205 277.176,213.739  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FFB655"
  },
  points: "34.957,77.854 34.957,401.041 77.317,401.041 77.317,129.937  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FFB655"
  },
  points: "408.884,213.739 477.05,129.933 477.05,77.854 387.704,187.699  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FFB655"
  },
  points: "187.835,213.739 277.177,103.894 255.996,77.854 166.656,187.698  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FFB655"
  },
  points: "103.236,161.809 145.473,213.739 187.712,161.809 145.473,109.879  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FFB655"
  },
  points: "324.287,161.809 366.524,213.739 408.762,161.809 366.524,109.879  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FF7956"
  },
  points: "84.754,285.205 112.135,318.87 139.518,285.205 112.135,251.539  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FF7956"
  },
  points: "427.254,285.205 399.872,318.87 372.489,285.205 399.872,251.539  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FF7956"
  },
  points: "197.875,285.205 256.003,356.671 314.132,285.205 256.003,213.739  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FF7956"
  },
  points: "84.754,285.205 112.135,318.87 139.518,285.205 112.135,251.539  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FF7956"
  },
  points: "427.254,285.205 399.872,318.87 372.489,285.205 399.872,251.539  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FF7956"
  },
  points: "197.875,285.205 256.003,356.671 314.132,285.205 256.003,213.739  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FF3F62"
  },
  points: "105.928,285.205 122.722,264.555 112.135,251.539 84.754,285.205 112.135,318.87  122.722,305.854  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FF3F62"
  },
  points: "393.663,285.205 410.458,264.555 399.872,251.539 372.489,285.205 399.872,318.87  410.458,305.854  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FF3F62"
  },
  points: "226.589,285.205 270.359,231.389 256.003,213.739 197.875,285.205 256.003,356.671  270.359,339.02  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  style: {
    fill: "#FFE477"
  },
  cx: 34.957,
  cy: 50.4,
  r: 27.457
}), /*#__PURE__*/React.createElement("circle", {
  style: {
    fill: "#FFE477"
  },
  cx: 256.007,
  cy: 50.4,
  r: 27.457
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  style: {
    fill: "#FFB655"
  },
  cx: 145.478,
  cy: 88.889,
  r: 20.995
}), /*#__PURE__*/React.createElement("circle", {
  style: {
    fill: "#FFB655"
  },
  cx: 366.525,
  cy: 88.889,
  r: 20.995
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FF7956"
  },
  points: "123.196,161.809 155.454,122.15 145.473,109.879 103.236,161.809 145.473,213.739  155.454,201.468  "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#FF7956"
  },
  d: "M145.474,109.879c3.613,0,7.012-0.914,9.98-2.521c-6.559-3.551-11.014-10.491-11.014-18.474 c0-7.982,4.455-14.923,11.014-18.474c-2.969-1.607-6.368-2.521-9.98-2.521c-11.595,0-20.995,9.4-20.995,20.995 C124.479,100.479,133.879,109.879,145.474,109.879z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#FF7956"
  },
  d: "M365.49,88.884c0-7.982,4.455-14.923,11.014-18.474c-2.969-1.607-6.368-2.521-9.981-2.521 c-11.595,0-20.995,9.4-20.995,20.995s9.4,20.995,20.995,20.995c3.613,0,7.012-0.914,9.981-2.521 C369.945,103.807,365.49,96.867,365.49,88.884z"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FF7956"
  },
  points: "344.247,161.809 376.504,122.15 366.524,109.879 324.287,161.809 366.524,213.739  376.504,201.468  "
})), /*#__PURE__*/React.createElement("circle", {
  style: {
    fill: "#FFE477"
  },
  cx: 477.043,
  cy: 50.4,
  r: 27.457
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#FFB655"
  },
  d: "M474.521,50.398c0-10.674,6.095-19.918,14.99-24.461c-3.742-1.911-7.977-2.996-12.467-2.996 c-15.164,0-27.457,12.293-27.457,27.457s12.293,27.457,27.457,27.457c4.49,0,8.725-1.085,12.467-2.996 C480.614,70.316,474.521,61.072,474.521,50.398z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#FFB655"
  },
  d: "M32.434,50.398c0-10.674,6.095-19.918,14.99-24.461c-3.742-1.911-7.977-2.996-12.467-2.996 C19.793,22.941,7.5,35.234,7.5,50.398s12.293,27.457,27.457,27.457c4.49,0,8.725-1.085,12.467-2.996 C38.527,70.316,32.434,61.072,32.434,50.398z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#FFB655"
  },
  d: "M253.481,50.398c0-10.674,6.095-19.918,14.99-24.461c-3.742-1.911-7.977-2.996-12.467-2.996 c-15.164,0-27.457,12.293-27.457,27.457s12.293,27.457,27.457,27.457c4.49,0,8.725-1.085,12.467-2.996 C259.574,70.316,253.481,61.072,253.481,50.398z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 316.968,
  y: 199.155,
  transform: "matrix(0.7758 -0.631 0.631 0.7758 -57.6488 251.0707)",
  style: {
    fill: "#FFFFFF"
  },
  width: 15,
  height: 15
}), /*#__PURE__*/React.createElement("rect", {
  x: 239.215,
  y: 150.281,
  transform: "matrix(-0.631 -0.7758 0.7758 -0.631 341.9705 478.2218)",
  style: {
    fill: "#FFFFFF"
  },
  width: 91.01,
  height: 15
}), /*#__PURE__*/React.createElement("rect", {
  x: 332.767,
  y: 218.534,
  transform: "matrix(0.631 0.7758 -0.7758 0.631 300.9162 -180.5674)",
  style: {
    fill: "#FFFFFF"
  },
  width: 15,
  height: 15
}), /*#__PURE__*/React.createElement("rect", {
  x: 442.504,
  y: 145.879,
  style: {
    fill: "#FFFFFF"
  },
  width: 15,
  height: 15
}), /*#__PURE__*/React.createElement("rect", {
  x: 442.504,
  y: 170.878,
  style: {
    fill: "#FFFFFF"
  },
  width: 15,
  height: 15
}), /*#__PURE__*/React.createElement("rect", {
  x: 442.504,
  y: 195.878,
  style: {
    fill: "#FFFFFF"
  },
  width: 15,
  height: 65.329
}), /*#__PURE__*/React.createElement("rect", {
  x: 390.005,
  y: 415.825,
  style: {
    fill: "#FFFFFF"
  },
  width: 15,
  height: 15
}), /*#__PURE__*/React.createElement("rect", {
  x: 277.006,
  y: 415.825,
  style: {
    fill: "#FFFFFF"
  },
  width: 102.999,
  height: 15
}), /*#__PURE__*/React.createElement("rect", {
  x: 415.004,
  y: 415.825,
  style: {
    fill: "#FFFFFF"
  },
  width: 15,
  height: 15
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 121.798,
  y: 415.825,
  style: {
    fill: "#1D1D1F"
  },
  width: 15,
  height: 15
}), /*#__PURE__*/React.createElement("rect", {
  x: 71.795,
  y: 415.825,
  style: {
    fill: "#1D1D1F"
  },
  width: 15,
  height: 15
}), /*#__PURE__*/React.createElement("rect", {
  x: 96.799,
  y: 415.825,
  style: {
    fill: "#1D1D1F"
  },
  width: 15,
  height: 15
}), /*#__PURE__*/React.createElement("rect", {
  x: 454.834,
  y: 413.665,
  style: {
    fill: "#1D1D1F"
  },
  width: 15,
  height: 19.32
}), /*#__PURE__*/React.createElement("rect", {
  x: 42.179,
  y: 413.665,
  style: {
    fill: "#1D1D1F"
  },
  width: 15,
  height: 19.32
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#1D1D1F"
  },
  d: "M27.457,496.559H484.55v-58.45H27.457V496.559z M42.456,453.109h427.094v28.451H42.456V453.109z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#1D1D1F"
  },
  d: "M75.086,285.205l37.049,45.551l37.051-45.551l-37.051-45.551L75.086,285.205z M112.135,306.984 l-17.715-21.78l17.715-21.78l17.716,21.78L112.135,306.984z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#1D1D1F"
  },
  d: "M362.821,285.205l37.051,45.551l37.049-45.551l-37.049-45.551L362.821,285.205z M399.872,306.984 l-17.716-21.78l17.716-21.78l17.715,21.78L399.872,306.984z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#1D1D1F"
  },
  d: "M188.207,285.205l67.794,83.352l67.797-83.352l-67.797-83.352L188.207,285.205z M248.503,292.704 v42.859l-34.86-42.859H248.503z M213.643,277.705l34.86-42.859v42.859H213.643z M263.502,292.704h34.862l-34.862,42.86V292.704z  M263.502,277.705v-42.859l34.862,42.859H263.502z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#1D1D1F"
  },
  d: "M512,50.398c0-19.275-15.682-34.957-34.957-34.957c-19.275,0-34.957,15.682-34.957,34.957 c0,14.477,8.846,26.925,21.417,32.227l-96.98,119.229l-96.98-119.229c12.57-5.302,21.416-17.75,21.416-32.227 c0-19.275-15.682-34.957-34.957-34.957s-34.957,15.682-34.957,34.957c0,14.473,8.842,26.919,21.406,32.223l-96.979,119.232 L48.501,82.622c12.568-5.303,21.411-17.75,21.411-32.225c0-19.275-15.682-34.957-34.957-34.957C15.682,15.441,0,31.123,0,50.398 c0,16.701,11.775,30.695,27.457,34.138V408.54H484.55V84.533C500.228,81.088,512,67.096,512,50.398z M236.047,50.398 c0-11.004,8.953-19.957,19.957-19.957c11.004,0,19.957,8.953,19.957,19.957s-8.953,19.957-19.957,19.957 C245,70.355,236.047,61.402,236.047,50.398z M15,50.398c0-11.004,8.953-19.957,19.957-19.957s19.957,8.953,19.957,19.957 S45.96,70.355,34.957,70.355C23.953,70.355,15,61.402,15,50.398z M450.501,393.54v-36.87h-15v36.87H42.456v-29.37h42.296v-15 H42.456V98.962l103.019,126.663L255.997,89.74l110.526,135.884L469.551,98.96v294.58H450.501z M477.043,70.355 c-11.004,0-19.957-8.953-19.957-19.957s8.953-19.957,19.957-19.957S497,39.394,497,50.398S488.047,70.355,477.043,70.355z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#1D1D1F"
  },
  d: "M342.994,150.694l23.53-28.93l23.531,28.93l11.637-9.465l-22.023-27.076 c9.112-4.759,15.35-14.297,15.35-25.27c0-15.712-12.783-28.495-28.495-28.495s-28.495,12.783-28.495,28.495 c0,10.973,6.238,20.51,15.35,25.27l-22.023,27.076L342.994,150.694z M366.524,75.39c7.441,0,13.495,6.054,13.495,13.495 s-6.054,13.495-13.495,13.495c-7.441,0-13.495-6.054-13.495-13.495C353.029,81.443,359.083,75.39,366.524,75.39z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#1D1D1F"
  },
  d: "M121.945,150.691l23.528-28.927l23.531,28.929l11.637-9.465l-22.023-27.075 c9.113-4.759,15.351-14.297,15.351-25.27c0-15.712-12.783-28.495-28.495-28.495s-28.495,12.783-28.495,28.495 c0,10.973,6.238,20.51,15.35,25.269l-22.021,27.073L121.945,150.691z M145.474,75.39c7.441,0,13.495,6.054,13.495,13.495 s-6.054,13.495-13.495,13.495c-7.441,0-13.495-6.054-13.495-13.495C131.979,81.443,138.033,75.39,145.474,75.39z"
})), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCrown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/crown.c203fe7c.svg";
export { ForwardRef as ReactComponent };